import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';
import { tablesApis } from 'pages/tables/services';

export const feedbackApis = createApi({
    reducerPath: 'feedbackApis',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
        prepareHeaders: (headers, { getState }) => {
            // Extract token from state
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getFeedback: builder.query({
            query: ({ search = "", page = 1, limit = 10, ratings, status, fromDate, toDate }) => ({
                url: '/pos/feedback',
                method: 'GET',
                params: { page, perPage: limit, search, ratings, status, fromDate, toDate }
            }),
            providesTags: ['feedabck'],
            //   transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),

        feedbackReply: builder.mutation({
            query: ({ id, body }) => ({
                url: `/pos/feedback/send-reply/${id}`,
                method: 'PUT',
                body: body
            }),
            invalidatesTags: ['feedabck'],
            transformErrorResponse: (error) => transformResponseHandler(error),
            // async onQueryStarted(arg, { dispatch, queryFulfilled }) {
            //     try {
            //         await queryFulfilled;
            //         dispatch(tablesApis.util.invalidateTags(['vendorTables']));
            //     } catch (err) {
            //         // do nothing
            //     }
            // },
        }),

        reportFeedback: builder.mutation({
            query: ({ id, body }) => ({
                url: `/pos/feedback/report/${id}`,
                method: 'PUT',
                body: body
            }),
            invalidatesTags: ['feedabck'],
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
    }),
});

export const { useGetFeedbackQuery, useFeedbackReplyMutation, useReportFeedbackMutation } = feedbackApis;